import { Component, inject } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { EMPTY } from "rxjs";
import { catchError, map, switchMap, tap } from "rxjs/operators";

import { AuthModel, Credentials, PermissionDeniedError } from "@intocare/auth-data";

@Component({
	templateUrl: "./confirm.component.html",
	styleUrls: ["./confirm.component.scss"],
	standalone: false,
})
export class ConfirmComponent {
	private readonly auth = inject(AuthModel);
	private readonly router = inject(Router);
	private readonly route = inject(ActivatedRoute);

	loading = false;
	organisation$ = this.route.paramMap.pipe(
		map((params: ParamMap) => {
			const org = params.get("org");
			const home = params.get("home");

			return home ? `${org}.${home}` : org;
		}),
	);

	onAuthenticate(credentials: Credentials) {
		this.loading = true;

		this.organisation$
			.pipe(
				switchMap((organisation) => this.auth.confirmPassword(credentials.newPassword, organisation)),
				catchError((error: unknown) => {
					if (error instanceof PermissionDeniedError) {
						this.router
							.navigate(["..", "no-permissions"], { relativeTo: this.route })
							.then(() => (this.loading = false))
							.catch(() => (this.loading = false));
						return EMPTY;
					}
					this.router
						.navigate(["..", "sign-in-with-username"], { relativeTo: this.route })
						.then(() => (this.loading = false))
						.catch(() => (this.loading = false));
					return EMPTY;
				}),
				tap(async () => {
					this.router
						.navigate(["..", "dashboard"], { relativeTo: this.route })
						.then(() => (this.loading = false))
						.catch(() => (this.loading = false));
				}),
			)
			.subscribe();
	}
}
